export type ThemePreference = 'system' | 'light' | 'dark';

export const DEFAULT_THEME_PREFERENCE: ThemePreference = 'light';

/**
 * Must outlive logout: preserved across `Preferences.clear()` in the auth
 * context's session-end handler (like `INTRO_SCREENS_SEEN_KEY`) so a user's
 * chosen theme survives logging out, but resets on app uninstall.
 */
export const THEME_PREFERENCE_KEY = 'THEME_PREFERENCE';

export const THEME_PREFERENCE_OPTIONS: {
  value: ThemePreference;
  label: string;
  description: string;
}[] = [
  {
    value: 'system',
    label: 'System',
    description: "Matches this device's display settings",
  },
  {
    value: 'light',
    label: 'Light',
    description: 'Always use the light theme',
  },
  {
    value: 'dark',
    label: 'Dark',
    description: 'Always use the dark theme',
  },
];
